import { render, staticRenderFns } from "./ManyResults.vue?vue&type=template&id=21b17a16&scoped=true"
import script from "./ManyResults.vue?vue&type=script&lang=js"
export * from "./ManyResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b17a16",
  null
  
)

export default component.exports